import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isPristine } from 'redux-form';
import _ from 'lodash';
import {
  saveCaseLevelAnalysis,
  updateTempCaseLevel,
  storeUnsavedAnalysis,
  removeStoredUnsavedAnalysis,
  setCaseStatus,
  saveAnalysis,
  updateCadessDataForCase
} from '../../redux/actions';
import { caseStatus } from '../../constants';
import CaseAndSpecimenAnalysisForm from '../../forms/caseAndSpecimenAnalysisForm/CaseAndSpecimenAnalysisForm';
import { buildCaseFormId } from '../../helpers/formIdCreator';

class CaseLevel extends Component {
  // TODO: refactor temporary saving, crashes if a user choose to logout and discard changes.
  state = { initialValues: {} }

  static getDerivedStateFromProps(props, state) {
    const { latestSavedValues, unsavedValues, pristine } = props;
    if (pristine && !_.isEmpty(state.initialValues)) {
      return null;
    }
    let initialValuesToBe;

    if (unsavedValues) {
      // SOURCE PRIORITY 1
      initialValuesToBe = Object.assign({}, unsavedValues);
    } else if (latestSavedValues) {
      // SOURCE PRIORITY 2
      initialValuesToBe = Object.assign({}, latestSavedValues);
    }

    if (initialValuesToBe) {
      const stateIsInSync = JSON.stringify(state.initialValues) === JSON.stringify(initialValuesToBe);
      if (!stateIsInSync) {
        return { initialValues: initialValuesToBe };
      }
    }

    return null;
  }

  componentDidMount() {
    const specimens = this.props._case.specimens;

    return this.props.updateCadessDataForCase(specimens);
  }

  componentDidUpdate() {
    const {
      pristine,
      currentFormValues,
      formId,
      removeStoredUnsavedAnalysis,
      latestSavedValues,
    } = this.props;
    if (!pristine && currentFormValues && latestSavedValues) {
      const currentIsInSyncWithLatestSaved = JSON.stringify(latestSavedValues) === JSON.stringify(currentFormValues);
      if (currentIsInSyncWithLatestSaved) {
        removeStoredUnsavedAnalysis(formId);
      }
    }
  }

  componentWillUnmount() {
    const {
      pristine,
      currentFormValues,
      formId,
      storeUnsavedAnalysis,
      latestSavedValues,
    } = this.props;
    if (!pristine && currentFormValues) {
      if (latestSavedValues) {
        const currentIsInSyncWithLatestSaved = JSON.stringify(latestSavedValues) === JSON.stringify(currentFormValues);
        if (!currentIsInSyncWithLatestSaved) {
          storeUnsavedAnalysis(currentFormValues, formId);
        }
      } else {
        storeUnsavedAnalysis(currentFormValues, formId);
      }
    }
  }

  saveAllUnsavedSpecimenAnalyzes = () => {
    this.props.unsavedAnalyzes
      .forEach(analysis => {
        const isCurrentPathologistAnalysis = analysis.formId.includes(this.props._case.currentPathologist._id);
        const isSpecimenAnalysis = analysis.formId.includes('specimen');

        if (isCurrentPathologistAnalysis && isSpecimenAnalysis) {
          const specimenId = analysis.formId.substring(analysis.formId.indexOf('specimen:') + 9, analysis.formId.indexOf(','));
          this.props.saveAnalysis(
            analysis.values,
            this.props._case.currentPathologist,
            specimenId,
            false, // old stuff: validationComplete,
            false, // old stuff: user.role === userRoles.val_pathologist,
            false,
            analysis.formId,
          );
        }

      })
    this.handleFormSubmit();
  }

  handleFormSubmit = () => {
    const { currentCase, saveCaseLevelAnalysis, currentFormValues, formId } = this.props;
    const _case = currentCase;
    /*   if (_case.analyses.length > 0) {
        // seems like this line of code is manipulating the redux form state AND IS THEREFORE NECESSARY
        _case.analyses.forEach(analysis => {
          if (analysis.assignee === this.props._case.currentPathologist._id) {
            analysis.analysis = currentFormValues;
            return analysis;
          } return analysis;
        });
      }
   */
    saveCaseLevelAnalysis(
      currentFormValues,
      this.props._case.currentPathologist,
      this.props._case.selectedCase.id,
      formId
    );

    _case.status.workflowStatus = caseStatus.workflowStatus.COMPLETE;
  };

  handleSubmitAllDemo = () => {
    const { setCaseStatus, currentCase } = this.props;
    const { workFlowStatusDemo: { ANALYSIS_SUBMITTED } } = caseStatus;
    setCaseStatus(ANALYSIS_SUBMITTED, currentCase.id);
  };

  goBackToStatusAwaitingAnalysis = () => {
    const { setCaseStatus, currentCase } = this.props;
    const { workFlowStatusDemo: { AWAITING_ANALYSIS } } = caseStatus;
    setCaseStatus(AWAITING_ANALYSIS, currentCase.id);
  }
  render() {
    const { _case, formId } = this.props;
    const { initialValues } = this.state;

    if (_case.showForm) {
      return (
        <div className="main-content">
          <CaseAndSpecimenAnalysisForm
            formSubmit={this.handleFormSubmit}
            handleSubmitAllDemo={this.handleSubmitAllDemo}
            form={formId}
            initValues={initialValues}
            saveAllUnsavedSpecimenAnalyzes={this.saveAllUnsavedSpecimenAnalyzes}
            goBackToStatusAwaitingAnalysis={this.goBackToStatusAwaitingAnalysis}
          />

        </div>
      );
    } return null;
  }
}

const mapStateToProps = (state) => {
  const { form, _case } = state;
  const { cases, selectedCase, currentPathologist, unsavedAnalyzes } = _case;
  const currentCase = cases.find(item => item.id === selectedCase.id);
  const formId = buildCaseFormId(selectedCase, currentPathologist);

  const pristine = isPristine(formId)(state);
  const currentFormValues = form[formId] !== undefined ? form[formId].values : null;
  const unsavedAnalysis = unsavedAnalyzes.find(analysis => analysis.formId === formId);
  const unsavedValues = unsavedAnalysis !== undefined ? unsavedAnalysis.values : null;
  let latestSavedValues;

  try {
    latestSavedValues = selectedCase
      .analyses
      .find(a => a.assignee === currentPathologist._id)
      .analysis;
  } catch (e) {
    latestSavedValues = null;
  }

  return {
    form,
    _case,
    pristine,
    currentCase,
    formId,
    currentFormValues,
    latestSavedValues,
    unsavedValues,
    unsavedAnalyzes,
  };
};

export default connect(
  mapStateToProps,
  {
    updateTempCaseLevel,
    saveCaseLevelAnalysis,
    storeUnsavedAnalysis,
    removeStoredUnsavedAnalysis,
    setCaseStatus,
    saveAnalysis,
    updateCadessDataForCase,
  },
)(CaseLevel);
